import React, { FC } from 'react';

import { Box, Group, Stack, Text, Title } from '@mantine/core';

import cx from './TextBlock.module.css';
import { gradient } from '@/../marketing/helpers/gradient';

const TextBlock: FC<{
    title?: React.ReactNode;
    titleGradient?: 'red' | 'green' | 'blue' | 'purple' | 'orange' | 'pink';
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
    children: React.ReactNode;
}> = ({ title, titleGradient, subtitle, actions, children }) => (
    <Stack gap="xl">
        {(title || subtitle) && (
            <Box>
                {title && (
                    <Text
                        component="h2"
                        className={cx.title}
                        fz={{ base: 24, md: 40 }}
                        style={gradient(titleGradient, 'text')}
                    >
                        {title}
                    </Text>
                )}
                {subtitle && <Title order={3}>{subtitle}</Title>}
            </Box>
        )}
        <Stack className={cx.text} gap="sm">
            {children}
        </Stack>
        {actions && <Group>{actions}</Group>}
    </Stack>
);

export { TextBlock };
